import { z } from "zod";

const MAX_FILE_SIZE = 5000000; /**5 MB */
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png"];

export const docFormSchema = z.object({
  driver_doc_type_id: z
    .string({ required_error: "Selecione o tipo" })
    .min(1, "Selecione o tipo"),
  expiration_date: z
    .date({
      invalid_type_error: "Data inválida",
    })
    .optional(),
  images: z
    .array(
      z
        .string()
        .refine((file) => {
          const [type] = file?.split("|") || [];
          return type && ACCEPTED_IMAGE_TYPES.includes(type);
        }, "Somente arquivos .jpg, .jpeg, .png são suportados")
        .refine((file) => {
          const [, size = "0"] = file?.split("|") || [];
          return Number(size) <= MAX_FILE_SIZE; // Converte 'size' para número
        }, `Tamanho máximo de arquivo 5MB.`)
    )
    .min(1, "Selecione pelo menos um arquivo"),
});
